import ADD_COUNTRY from "./addCountry"
import ADD_LABEL from "./addLabel"
import ADD_STORE from "./addStore"
import ADD_STORE_LINK from "./addStoreLink"
import ADD_VENDOR from "./addVendor"
import BULK_UPDATE_STORE_LINKS from "./bulkUpdateStoreLinks"
import DELETE_COUNTRY from "./deleteCountry"
import DELETE_LABEL from "./deleteLabel"
import DELETE_STORE from "./deleteStore"
import DELETE_STORE_LINK from "./deleteStoreLink"
import DELETE_VENDOR from "./deleteVendor"
import UPDATE_COUNTRY from "./updateCountry"
import UPDATE_LABEL from "./updateLabel"
import UPDATE_STORE from "./updateStore"
import UPDATE_STORE_LINK from "./updateStoreLink"
import UPDATE_VENDOR from "./updateVendor"

export default {
  ADD_COUNTRY,
  ADD_LABEL,
  ADD_STORE,
  ADD_STORE_LINK,
  ADD_VENDOR,
  BULK_UPDATE_STORE_LINKS,
  DELETE_COUNTRY,
  DELETE_LABEL,
  DELETE_STORE,
  DELETE_STORE_LINK,
  DELETE_VENDOR,
  UPDATE_COUNTRY,
  UPDATE_LABEL,
  UPDATE_STORE,
  UPDATE_STORE_LINK,
  UPDATE_VENDOR
}
